import { Component, OnInit } from '@angular/core';
import { PermissionsService } from '../../services/permissions/permissions.service';
import { MatSnackBar } from '@angular/material';
import { ToastComponent } from '../toast/toast.component';

@Component({
    selector: 'app-permissions',
    templateUrl: './permissions.component.html',
    styleUrls: ['./permissions.component.scss']
})
export class PermissionsComponent implements OnInit {

    public rules = [];
    public permissions = [];
    public domain_permissions_rules = [];

    public loading = true;
    public atualPage = 'permissoes';

    constructor(
        public permissionsService: PermissionsService,
        private snackBar: MatSnackBar
    ) { }

    ngOnInit() {
        this.init();
    }


    init() {
        this.loading = true;
        this.list(() => {
            this.rules.forEach((rule) => {
                if (!rule.multiple_permissions) {
                    rule.enabled = false;
                    this.domain_permissions_rules.forEach((item) => {
                        if (item.rules_id == rule.id) {
                            rule.enabled = true;
                        }
                    })
                } else {
                    rule.permissions = JSON.parse(JSON.stringify(this.permissions));
                    rule.permissions.forEach((permission) => {
                        permission.enabled = false;
                        this.domain_permissions_rules.forEach((item) => {
                            if ((item.permissions_id == permission.id) && (item.rules_id == rule.id)) {
                                rule.enabled = true;
                                permission.enabled = true
                            }
                        })
                    })
                }
                this.loading = false;
            })
        });
    }


    list(callback) {
        this.permissionsService.list().subscribe((res) => {
            this.rules = res.rules;
            this.permissions = res.permissions;
            this.domain_permissions_rules = res.domain_permissions_rules;
            
            callback()
        })
    }

    save() {
        this.loading = true;
        let rules = this.rules;
        this.permissionsService.save(rules).subscribe((res) => {
            this.init();
            this.snackBar.openFromComponent(ToastComponent, {
                data: res.msg
            });

        })
    }
}
